let authenticated = false; 
let user_name = "";
let user_email = "";
let user_id = -1;
let token = "na";
let language_code = 'es';
let groups = [];
let activeGroupID = -1;
let activeSubgroupID = -1;
let activeRoleID = -1;

const K_STORAGE_KEY = 'isLoggedIn'
var _ = require("lodash");


export default {
  authenticated() {
    // 2026-03-18 aospino para verificar q login este OK
    if (
      localStorage.getItem(K_STORAGE_KEY) === 'true' ||
      sessionStorage.getItem(K_STORAGE_KEY) === 'true'
    ) {
      //console.log("Se encuentra K_STORAGE_KEY")
      return true;
    }

    return authenticated;
  },
  get_user_name() {
    return user_name;
  },
  get_user_email() {
    return user_email;
  },
  get_id_group_active() {
    return activeGroupID;
  },
  get_id_subgroup_active() {
    return activeSubgroupID;
  },
  get_id_role_active() {
    return activeRoleID;
  },
  set_id_group_active(val) {
    activeGroupID=val;
  },
  set_id_subgroup_active(val) {
    activeSubgroupID=val;
  },
  set_id_role_active(val) {
    activeRoleID=val;
  },
  get_language() {
    return language_code;
  },
  get_user_id() {
    return user_id;
  },
  get_token() {
    return token;
  },
  get_Groups() {
    return groups;
  },
  set_token(val) {
    token=val;
  },
  set_groups(val) {
    groups=val;
  },
  set_language(val) {
    language_code=val;
  },
  loggedIn() {
    return !!this.authenticated();
  },
  logIn(pUsername,pUseremail,pUser_id,pToken) {
    authenticated = true;
    user_name = pUsername;
    user_email = pUseremail;
    user_id = pUser_id;
    token = pToken;
    localStorage.setItem("token", token);

    // 2026-03-18 aospino para guardar las keys de autenticacion
    let remember = false;
    if (remember) {
      localStorage.setItem(K_STORAGE_KEY, 'true')
      sessionStorage.removeItem(K_STORAGE_KEY)
    } else {
      sessionStorage.setItem(K_STORAGE_KEY, 'true')
      localStorage.removeItem(K_STORAGE_KEY)
    }

    return {
        isOk: true,
        data: {username:pUsername}
    };
  },
  logOut() {
    authenticated = false;
    user_name = "";
    user_email = "";
    user_id = -1;
    token = "";

    // 2026-03-18 aospino para limpiar las keys de autenticacion
    localStorage.removeItem(K_STORAGE_KEY)
    sessionStorage.removeItem(K_STORAGE_KEY)
    localStorage.removeItem(K_STORAGE_KEY+"_info");


    if (localStorage.getItem("token")) {
        localStorage.removeItem("token");
    }
  },

  saveAut2Storage(response) {
    let bOk = false;
    if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
      this.logIn(response.DATA.username,response.DATA.email,response.DATA.user_id,response.DATA.token);
      this.set_language(response.DATA.lang);
      this.set_groups(response.DATA.groups);
      this.set_id_group_active(response.DATA.groups[0]['id_group'])
      this.set_id_subgroup_active(response.DATA.groups[0]['id_subgroup']);
      this.set_id_role_active(response.DATA.groups[0]['id_role'])
      bOk = true;
    }
    let strJson = JSON.stringify(response);
    localStorage.setItem(K_STORAGE_KEY+"_info",strJson)
    return bOk;
  },
  loadAut4Storage() {
    let _this = this;
    const savedPrefs = localStorage.getItem(K_STORAGE_KEY+"_info");
    if (savedPrefs) {
      try {
        let response = JSON.parse(savedPrefs);
        _this.saveAut2Storage(response);
      } catch (e) {
//        localStorage.removeItem(K_STORAGE_KEY+"_info"); // handle errors
      }
    }

  },
};
